import { request } from "../utils/request.js"

export const getShareConfig = (url) => request({
    url: 'wxOffiAcc/getSignature',
    method: 'GET',
    params: { url },
})

export const login = (id) => request({
    url: 'user/login',
    method: 'GET',
    params: { id },
})

export const playerFindAll = (pojo) => request({
    url: 'cszx/player/findAll',
    method: 'POST',
    params: pojo,
})

export const getVotePlayerIdList = () => request({
    url: 'cszx/votesRecord/getVotePlayerIdList',
    method: 'GET',
})

export const vote = (playerId) => request({
    url: 'cszx/votesRecord/vote',
    method: 'GET',
    params: { playerId },
})


// WEBPACK FOOTER //
// ./src/api/api.js